import { render, staticRenderFns } from "./PileCard.vue?vue&type=template&id=fd301988&scoped=true"
import script from "./PileCard.vue?vue&type=script&lang=js"
export * from "./PileCard.vue?vue&type=script&lang=js"
import style0 from "./PileCard.vue?vue&type=style&index=0&id=fd301988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd301988",
  null
  
)

export default component.exports